import * as Styles from "layouts/PrivateLayout.styles"
import {Typography} from "@mui/material"
import {IBookingSlot} from "services/bookingSlots"
import {formatDateShort, formatTimeRange} from "utils/intlDate"
import {useGetLocationsQuery} from "../../../../services/locations";
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";

const BookingData: React.FC<IBookingSlot | any> = ({ booking }) => {
    const dateOnly = formatDateShort(new Date(booking?.date_start ?? new Date()))
    const dateTimeRange = formatTimeRange(new Date(booking?.date_start ?? new Date()),new Date(booking?.date_end ?? new Date()) )
    const [locationName, setLocationName] = useState<string>("")
    const [locationId, setLocationId] = useState<string>("")

    const { data: locationsData } = useGetLocationsQuery({ limit: 999 });
    const getLocationName = () => {
        const location = locationsData?.locations.find(loc => loc.id === booking?.location_id);
        return location ? location.name : 'Unknown Location';
    };

    const getLocationId = () => {
        const location = locationsData?.locations.find(loc => loc.id === booking?.location_id);
        return location ? location.id : '';
    }

    useEffect(() => {
        setLocationName(getLocationName())
        setLocationId(getLocationId())
    }, [locationsData, booking?.location_id]);

    return <>
        <Styles.FlexContainer flex-col className="mt-4">
            <Styles.FlexContainerColumn className="pr-16">
                <Typography sx={{ fontSize: 14 }}>
                    Date And Time
                </Typography>
            </Styles.FlexContainerColumn>
            <Styles.FlexContainerColumn className="pr-16 mt-2">
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                   Date: { dateOnly }
                </Typography>
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                    Time: { dateTimeRange }
                </Typography>
            </Styles.FlexContainerColumn>
            <Styles.FlexContainerColumn className="pr-16 pt-4">
                <Typography sx={{ fontSize: 14 }}>
                    Product 
                </Typography>
            </Styles.FlexContainerColumn>
            <Styles.FlexContainerColumn className="pr-16 mt-2">
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                    Name: { booking?.order_line_item?.name }
                </Typography>
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                    Quantity: { booking?.order_line_item?.quantity }
                </Typography>
            </Styles.FlexContainerColumn>
            <Styles.FlexContainerColumn className="pr-16 pt-4">
                <Typography sx={{ fontSize: 14 }}>
                    Location 
                </Typography>
            </Styles.FlexContainerColumn>
            <Styles.FlexContainerColumn className="pr-16 mt-2">
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                    <Link to={`/admin/locations/${locationId}`} className="text-blue-500">{ locationName }</Link>
                </Typography>
            </Styles.FlexContainerColumn>
        </Styles.FlexContainer>
    </>
}

export default BookingData
